import styled from 'styled-components';
import { MultiBarGraphProps, MultiBarProps } from './type';

export const WrapMultiBarGraphStyle = styled.div<MultiBarGraphProps>`
  overflow-x: scroll;
  display: grid;
  gap: 10px;
  overflow-y: visible;
  grid-template-columns: max-content 1fr;
  width: ${({ maxWidth }) => maxWidth || '100%'};
  height: ${({ maxHeight }) => `calc(${maxHeight} || '100%' + 100px)`};
`;

export const WrapMultiLabelStyle = styled.div<MultiBarGraphProps>`
  width: ${({ labelWidth }) => labelWidth || '50px'};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${({ maxHeight }) => `calc(${maxHeight})`};
  padding-bottom: 40px;
  padding-top: 0px;
`;

export const BackgroundMultiBarStyle = styled.div`
  box-shadow: 4px 4px 14px 0px #c1d5ee inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
  background-color: #e3edf7;
  border-radius: 10px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
`;

export const WrapMultiBarStyle = styled.div<MultiBarProps>`
  display: flex;
  align-items: flex-end;
  gap: 2px;
  position: relative;
  ::before {
    content: ${({ label }) => (label ? `'${label}'` : '')};
    position: absolute;
    bottom: -20px;
    text-align: center;
    width: 100%;
    z-index: 1;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #5b5d71;
  }
  ::after {
    content: ${({ title: name }) => (name ? `'${name}'` : '')};
    position: absolute;
    bottom: -40px;
    text-align: center;
    width: 100%;
    z-index: 1;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #5b5d71;
  }
`;

export const MultiBarStyle = styled.span<MultiBarProps>`
  height: ${({ graphValue }) => `${graphValue < 100 ? graphValue : 100}%` || '0%'};
  max-height: ${({ graphValue }) => `calc(${graphValue < 100 ? graphValue : 100}%)` || '0%'};
  width: ${({ size }) => size || '12px'};
  border-radius: 10px;
  background: ${({ theme: { colors }, color }) =>
    color || `linear-gradient(to bottom, #50CAFF, ${colors.blue500})`};
  position: relative;
`;
